import { useState } from 'react';
import { Dialog } from '@effizency/efz-design-system';
import { Button } from '@effizency/efz-design-system';

import { ReactComponent as CheckIcon } from 'assets/@efz/icons/step_valid.svg';

import { LanguageSelectorDialogContent } from 'components/@efz/Sidebar/StylesSidebar';
import IntlMessages from 'components/util/IntlMessages';

const LanguageSelectorDialog = ({
    isOpen,
    handleClose,
    languages,
    switchLanguage,
    currentLocale,
}: {
    isOpen: boolean;
    handleClose: () => void;
    languages: any[];
    switchLanguage: (locale: any) => void;
    currentLocale: string;
}) => {
    const [selectedLanguage, setSelectedLanguage] = useState(() => {
        return (
            languages.find((l: any) => l.locale === currentLocale || l.appLocale === currentLocale || l.icon === currentLocale) ??
            languages[0]
        );
    });

    const handleConfirm = () => {
        if (selectedLanguage) {
            const selectedCode = selectedLanguage.locale ?? selectedLanguage.appLocale;
            if (selectedCode !== currentLocale) {
                switchLanguage(selectedLanguage);
            }
        }
        handleClose();
    };

    return (
        <Dialog
            dataTestId="language-selector-dialog"
            title={'Select Language'}
            onClose={handleClose}
            open={isOpen}
            maxWidth="md"
            tertiaryButton={
                <Button variant="tertiary" onClick={handleClose} dataTestId="cancel-change-language">
                    <IntlMessages id="label.cancel" />
                </Button>
            }
            primaryButton={
                <Button onClick={handleConfirm} dataTestId="confirm-change-language">
                    <IntlMessages id="label.confirm" />
                </Button>
            }
        >
            <LanguageSelectorDialogContent>
                <ul>
                    {languages.map((lang) => {
                        const isSelected = selectedLanguage?.appLocale === lang.appLocale;
                        return (
                            <li
                                key={lang.appLocale}
                                onClick={() => setSelectedLanguage(lang)}
                                className={isSelected ? 'selected' : undefined}
                            >
                                <div>
                                    <IntlMessages id={lang.name} /> ({lang.appLocale})
                                </div>
                                {isSelected && <CheckIcon />}
                            </li>
                        );
                    })}
                </ul>
            </LanguageSelectorDialogContent>
        </Dialog>
    );
};

export default LanguageSelectorDialog;
